import { useEffect, useState } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { AppShell } from './components/layout/AppShell';
import { auth } from './lib/api';
import { BlogPostsPage } from './pages/BlogPostsPage';
import { CampaignsPage } from './pages/CampaignsPage';
import { ContentChannelPage } from './pages/ContentChannelPage';
import { ContentTopicsPage } from './pages/ContentTopicsPage';
import { DashboardPage } from './pages/DashboardPage';
import { EmailsPage } from './pages/EmailsPage';
import { InboxPage } from './pages/InboxPage';
import { JobsPage } from './pages/JobsPage';
import { LeadTypesPage } from './pages/LeadTypesPage';
import { LeadsPage } from './pages/LeadsPage';
import { LoginPage } from './pages/LoginPage';
import { MailboxPage } from './pages/MailboxPage';
import { ProjectOverviewPage } from './pages/ProjectOverviewPage';
import { ProjectsPage } from './pages/ProjectsPage';
import { SettingsPage } from './pages/SettingsPage';
import { TemplatesPage } from './pages/TemplatesPage';

const NotFound = () => (
  <div className="flex h-full flex-col items-center justify-center gap-2 text-center">
    <h1 className="text-lg font-semibold">Page not found</h1>
    <a href="/" className="text-[13px] text-brand hover:underline">
      Back to the dashboard
    </a>
  </div>
);

export const App = () => {
  const location = useLocation();
  const projectKey = location.pathname.match(/^\/projects\/([^/]+)/)?.[1] ?? 'workspace';
  // The token lives in localStorage; subscribing keeps every tab and every 401 in sync.
  const [token, setToken] = useState(auth.token);
  useEffect(() => auth.subscribe(setToken), []);

  if (!token) return <LoginPage />;

  return (
    <AppShell>
      <Routes key={projectKey}>
        <Route path="/" element={<DashboardPage />} />
        <Route path="/projects" element={<ProjectsPage />} />
        <Route path="/projects/:projectId" element={<ProjectOverviewPage />} />
        <Route path="/projects/:projectId/lead-types" element={<LeadTypesPage />} />
        <Route path="/projects/:projectId/leads" element={<LeadsPage />} />
        <Route path="/projects/:projectId/campaigns" element={<CampaignsPage />} />
        <Route path="/projects/:projectId/templates" element={<TemplatesPage />} />
        <Route path="/projects/:projectId/emails" element={<EmailsPage />} />
        <Route path="/projects/:projectId/inbox" element={<InboxPage />} />
        <Route path="/projects/:projectId/topics" element={<ContentTopicsPage />} />
        <Route path="/projects/:projectId/posts" element={<BlogPostsPage />} />
        <Route path="/projects/:projectId/content-channel" element={<ContentChannelPage />} />
        <Route path="/projects/:projectId/jobs" element={<JobsPage />} />
        <Route path="/projects/:projectId/mailbox" element={<MailboxPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/login" element={<Navigate to="/" replace />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </AppShell>
  );
};
